import { AxiosResponse } from 'axios';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useDreConfigContext } from 'pages/financeiro/dre/configuracao/contexts/DreConfigContext';
import { DreSubgrupo } from 'pages/financeiro/dre/configuracao/types';

export function useSortSubgrupos() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<DreSubgrupo>>();
    const { subgrupos, setSubgrupos } = useDreConfigContext();
    const { showError } = useShowError();

    /**
     * Retorna um objeto com a sequência dos subgrupos.
     */
    const getSortSubgrupos = (newSubgrupos: DreSubgrupo[]) => {
        const sequencia: Record<number, number> = {};

        newSubgrupos.forEach((subgrupo, index) => {
            sequencia[subgrupo.idDreMercadologicaGrupoExibicao] = index + 1;
        });

        return sequencia;
    };

    /**
     * Faz request para atualizar a sequência dos subgrupos.
     */
    const updateSort = (newSubgrupos: DreSubgrupo[]) => {
        mutate(
            {
                formData: getSortSubgrupos(newSubgrupos),
                method: 'PUT',
                url: '/dre/dremercadologicagrupoexibicao/ordenacao',
                preventSnack: true,
                preventRedirect: true,
            },
            {
                onError: (error) => {
                    setSubgrupos(subgrupos);

                    showError(error, 'Falha ao ordenar subgrupos');
                },
            },
        );
    };

    return { updateSort, isLoading };
}
